<div class="wrapper">
  <div class="list-wrapper" #element>
    <div class="list" #list>
      <ng-content></ng-content>
    </div>
  </div>
  @if (numBars && !(mobile() && hideDotsIfMobile())) {
    <div class="bars-wrapper">
      <div class="centered-bars">
        <app-scrolling-bars [perc]="perc()" [num_bars]="numBars()" (selectBar)="selectBar($event)" />
      </div>
    </div>
  }
</div>
@if (scrool$ | async) {}
